var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M80,60c0,22.1-17.9,40-40,40C17.9,100,0,82.1,0,60c0-5.9,1.3-11.5,3.6-16.6l6.1,6.1C8.6,52.8,8,56.3,8,60 c0,17.6,14.4,32,32,32s32-14.4,32-32c0-3.7-0.6-7.2-1.8-10.5l6.2-6.1C78.7,48.5,80,54.1,80,60z M40,20c-5.9,0-11.5,1.3-16.6,3.6 l6.1,6.2C32.8,28.6,36.3,28,40,28c3.7,0,7.2,0.6,10.5,1.8l6.2-6.2C51.5,21.3,45.9,20,40,20z M90.9,0.6L40,51.5L8.9,20.4l-8.5,8.5 L31.5,60l8.5,8.5l8.5-8.5L99.4,9.1L90.9,0.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon05);
export default __webpack_public_path__ + "static/media/motion_icon-05.cbfd4810.svg";
export { ForwardRef as ReactComponent };